import React, { PureComponent } from 'react';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import config from '../../../../config';
import Panel from '../../../../shared/components/Panel';
import { SellerSelect, User, Theme } from '../../../../shared/prop-types/MainProps';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../shared/helpers/themeTableStyles';


class PromotionEvents extends PureComponent {
  static propTypes = {
    sellerSelect: SellerSelect.isRequired,
    user: User.isRequired,
    theme: Theme.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      apiData: [],
      initalLoad: false,
    };

    this.getColor = this.getColor.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevState) {
    const { sellerSelect } = this.props;
    if (sellerSelect.value !== prevState.sellerSelect.value) {
      this.getData();
    }
  }

  getData = () => {
    const { user, sellerSelect } = this.props;

    const apiEndPoint = config.isProdEnv ? config.serverProdUrl : config.serverDevUrl;

    const headerWithAuth = { ...config.jsonHeader, authorization: `JWT ${user.jwtToken}` };

    const getUrl = `${apiEndPoint}/events/calendar/seller?sellerAccountId=${sellerSelect.value.toString()}&parentAccountId=${sellerSelect.parentAccountId}`;

    if (sellerSelect.value > 0) {
      const requestOptions = {
        method: 'GET',
        headers: headerWithAuth,
      };
      this.setState({
        initalLoad: true,
      });
      // Call via API (would like to update to " await ")
      fetch(getUrl, requestOptions)
        .then((results) => {
          if (!results.ok) {
            throw Error(results.statusText);
          }
          return results.json();
        }).then((data) => {
          this.setState({
            initalLoad: false,
            apiData: data,
          });
          return data;
        }).catch(() => {
          this.setState({
            initalLoad: false,
          });
        });
    }
  };

  getColor = (input) => {
    let color;

    if (input && input.charAt(0) === '#') {
      return input;
    }

    switch (input) {
      case 'high':
        color = '#C3485F';
        break;

      case 'medium':
        color = '#4ce1b6';
        break;

      case 'normal':
        color = '#E87B50';
        break;

      case 'low':
        color = '#808080';
        break;

      default:
        color = '#000000';
        break;
    }
    return color;
  }

  render() {
    const { apiData, initalLoad } = this.state;
    const { theme } = this.props;
    const isDarkMode = isDarkTheme(theme);
    let recentUpcomingMsg = 'No Recent or Upcoming Events Found';
    let rowIndex = 0;

    return (
      <Panel lg={12} title="Seller Account Promotion Calendar" getData={this.getData} parentRefresh={initalLoad}>
        <div style={getTableWrapperStyle(isDarkMode)}>
          <Table responsive className="table--bordered">
            <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
              <tr>
                <th style={getTableHeaderStyle(isDarkMode)}>#</th>
                <th style={getTableHeaderStyle(isDarkMode)}>Event/Promotion Name</th>
                <th style={getTableHeaderStyle(isDarkMode)}>Start Date</th>
                <th style={getTableHeaderStyle(isDarkMode)}>End Date</th>
                <th style={getTableHeaderStyle(isDarkMode)}>Priority</th>
              </tr>
            </thead>
            <tbody>
              {apiData && apiData.map(line => {
                if (moment(line.end) > moment().subtract(13, 'months')) {
                  recentUpcomingMsg = null;
                  const rowStyle = getTableRowStyle(isDarkMode, rowIndex % 2 === 1);
                  rowIndex += 1;
                  return (
                    <tr key={line.calendar_id} style={rowStyle}>
                      <td style={rowStyle}>{line.calendar_id}</td>
                      <td style={rowStyle}>{line.title}</td>
                      <td style={rowStyle}>{line.start.substring(0, line.start.indexOf('T'))}</td>
                      <td style={rowStyle}>{line.end.substring(0, line.end.indexOf('T'))}</td>
                      <td style={rowStyle}><div className="badge" style={{ backgroundColor: this.getColor(line.priority) }}>{line.priority}</div></td>
                    </tr>
                  );
                }
                return '';
              })}
            </tbody>
          </Table>
        </div>
        {!initalLoad && recentUpcomingMsg && (
          <div>{recentUpcomingMsg}</div>
        )}
      </Panel>
    );
  }
}

const mapStateToProps = (state) => {
  const { sellerSelect, theme } = state;
  const { user } = state.authentication;

  return {
    sellerSelect,
    user,
    theme,
  };
};

export default connect(mapStateToProps)(PromotionEvents);
